import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleRubric extends BaseModel {
  static override constructorName = 'ArticleRubric'

  id: number = 0
  name: string = ''
  slug: string = ''
  image: string = ''
  'sort_index': number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
      this.image = toCroppedImage(this.image)
    }
  }
}

registerModel(ArticleRubric)
